import { defineMessages } from "react-intl";

const messages = defineMessages({
  delete: {
    id: "settings.fileTags.list.bulk.delete",
    defaultMessage: "Delete",
    description: "Delete button for bulk tags delete",
  },
  deleteConfirm: {
    id: "settings.fileTags.list.bulk.delete.confirm",
    defaultMessage:
      "Are you sure you want to delete {count, plural, one {this tag} other {these tags}}? This action cannot be undone.",
    description: "Delete confirm message for bulk tags delete",
  },
  deselectAll: {
    id: "settings.fileTags.list.deselectAll",
    defaultMessage: "Deselect All",
    description: "Deselect all button for bulk tags",
  },
  private: {
    id: "settings.fileTags.list.tags.visibility.private",
    defaultMessage: "Private",
    description: "Private option for file tags visibility",
  },
  selectAll: {
    id: "settings.fileTags.list.selectAll",
    defaultMessage: "Select All",
    description: "Select all button for bulk tags",
  },
  selectedCount: {
    id: "settings.fileTags.list.selected.count",
    defaultMessage: "{count} selected",
    description: "Count for selected tags for bulk edit",
  },
  shareWith: {
    id: "settings.fileTags.list.tags.shareWith",
    defaultMessage: "Share With",
    description: "Share with text for sharing",
  },
  sharing: {
    id: "settings.fileTags.list.bulk.share",
    defaultMessage: "Sharing",
    description: "Share button for bulk tags edit",
  },
  tagsCount: {
    id: "settings.fileTags.list.tags.count",
    defaultMessage: "{total, select, 0 {0 shown} other {{startRange}-{endRange} of {total} shown}}",
    description: "Tags count info on current page",
  },
});

export default messages;
